/* global document, setTimeout, window */

export default function(rootElement) {
  const hideModal = () => {
    const scrollPosition = parseInt(document.body.style.top, 10) * -1;

    document.body.classList.remove('body--freeze');
    document.body.style.top = 0;

    window.scrollTo(0, scrollPosition);

    rootElement.setAttribute('fading', '');

    setTimeout(() => {
      rootElement.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('html--instant-scroll');
    }, 330);
  };

  hideModal();

  window.removeEventListener('keyup', rootElement.escapeToClose, false);
}
